import React from "react";
import { Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FloatingField } from "../Global/Transitions";

type UserDetailsFormProps = {
  isEdit: boolean;
  isCreate: boolean;
  displayName: string;
  setDisplayName: (val: string) => void;
  email: string;
  handleEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEmailBlur: () => void;
  handleEmailFocus: () => void;
  creationType: number;
  setCreationType: (val: number) => void;
  saving: boolean;
};

export default function UserDetailsForm({
  isEdit,
  isCreate,
  displayName,
  setDisplayName,
  email,
  handleEmailChange,
  handleEmailBlur,
  handleEmailFocus,
  creationType,
  setCreationType,
  saving,
}: UserDetailsFormProps) {
  return (
    <>
      {isCreate && (
        <FloatingField label="Creation Type">
          <Form.Select
            //value={creationType}
            //onChange={(e) => setCreationType(Number(e.target.value))}
            disabled={true}
            defaultValue={0}
          >
            <option value={0}>Create User</option>
            {/* <option value={1}>Invite User (SSO)</option> */}
          </Form.Select>
        </FloatingField>
      )}
      
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip>
            These fields cannot be edited. Delete and recreate the user to change it.
          </Tooltip>
        }
        trigger={isEdit ? ["hover", "focus"] : []}
      >
        <div>
          <FloatingField
            label="Display Name"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Full name"
            disabled={isEdit}
          />

          <FloatingField
            label="Email Address"
            main
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="email@example.com"
            onBlur={handleEmailBlur}
            onFocus={handleEmailFocus}
            disabled={isEdit}
          />
        </div>
      </OverlayTrigger>
    </>
  );
}

